import { api } from '@/services/api/AxiosBaseService'
import type { ImportResult } from '@/components/EmployeeImportModal'

export type ImportJobStatus = 'PENDENTE' | 'PROCESSANDO' | 'CONCLUIDO' | 'FALHOU'

export interface ImportJobState {
  id: string
  status: ImportJobStatus
  result: ImportResult | null
  error: string | null
}

/**
 * Acompanha uma importação assíncrona: consulta o status a cada ~2,5s até concluir
 * ou falhar. Cada requisição é rápida (o trabalho pesado roda no job), então não
 * esbarra no timeout de 30s do axios. Resolve com o resultado ou lança em falha.
 */
export async function pollEmployeeImport(statusUrl: string, timeoutMs = 15 * 60_000): Promise<ImportResult> {
  const startedAt = Date.now()
  for (;;) {
    const r = await api.get<{ data: ImportJobState }>(statusUrl)
    const d = r.data.data
    if (d.status === 'CONCLUIDO' && d.result) return d.result
    if (d.status === 'FALHOU') throw new Error(d.error || 'Falha ao importar a planilha.')
    if (Date.now() - startedAt > timeoutMs) {
      throw new Error('A importação está demorando mais que o esperado. Aguarde e confira a lista de colaboradores em instantes.')
    }
    await new Promise((resolve) => setTimeout(resolve, 2500))
  }
}
